<template>
    <div class="room_page">
        <el-table :data="roomList" :border="true" ref="roomTable" v-loading="table_loading">
            <el-table-column prop="name" label="会议室名称"></el-table-column>
            <el-table-column prop="describe" label="描述"></el-table-column>
            <el-table-column prop="status" label="状态" v-if="userInfo.identity==1?true:false">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status==1? true:false" type="primary" disable-transitions>开放</el-tag>
                    <el-tag v-if="scope.row.status==2? true:false" type="warning" disable-transitions>停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" v-if="userInfo.identity==1?true:false">
                <template slot="header">
                    <el-button @click="createClick" size="small">新建</el-button>
                </template>
                <template slot-scope="scope">
                    <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="10"
            :current-page="currentPage"
            class="page_pagination"
            @next-click="handlePageChange"
            @prev-click="handlePageChange"
            @current-change="handlePageChange"
        >
        </el-pagination>
        <el-dialog
        :title="dialogTitle"
        :visible.sync="roomAddDialogVisible"
        width="30%"
        @close="dialogCloseHandle"
        center>
            <el-form :model="roomAdd" label-width="80px">
                <el-form-item label="会议室">
                    <el-input v-model="roomAdd.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="roomAdd.describe" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                    :action="uploadUrl"
                    :on-change="uploadImgHandle"
                    :on-remove="handleRemove"
                    list-type="picture-card"
                    :auto-upload='false'
                    :file-list="picList"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio v-model="roomAdd.status" :label="1">正常使用</el-radio>
                    <el-radio v-model="roomAdd.status" :label="2">暂停使用</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roomAddDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="roomAddHandle">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            roomList:[],
            roomAddDialogVisible: false,
            roomAdd: {
                name: null,
                describe: null,
                pic: null,
                status: 1
            },
            uploadUrl: '/room/upload_img',
            action: null,
            dialogTitle: null,
            editRoomId: null,
            picList: [],
            total:null,
            currentPage: 1,
            table_loading: false,
        }
    },
    mounted(){
        this.getRoomList()
    },
    methods: {
        handleDelete(row){
            this.$confirm('确认删除吗？')
            .then(() => {
                let roomId = row.id
                let url = `/room/${roomId}/`
                this.$axios.delete(url)
                .then(res => {
                    if (res.status) {
                        const index = this.roomList.findIndex((value) => value.id == roomId)
                        if (index != -1) {
                            this.roomList.splice(index,1)
                        }
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error('删除失败')
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        roomAddHandle(){
            if (!this.roomAdd.name) {
                this.$message.error('会议室名称不能为空')
            } else if (!this.roomAdd.describe) {
                this.$message.error('会议室描述不能为空')
            }
            let fd = new FormData()
            fd.append('name', this.roomAdd.name)
            fd.append('describe', this.roomAdd.describe)
            fd.append('status', this.roomAdd.status)
            if (this.roomAdd.pic) {
                fd.append('pic', this.roomAdd.pic)
            }
            let url = null
            if (this.action == 'create') {
                url = '/room/'
            } else if (this.action == 'edit') {
                url = '/room/'+ this.editRoomId + '/'
            }
            this.$confirm('确认提交吗？')
            .then(() => {
                if (this.action == 'create') {
                    this.$axios.post(url, fd)
                    .then(res => {
                        if (res.status === 1) {
                            console.log(res.data)
                            this.roomList.push(res.data)
                            this.$message.success('创建成功')
                            this.roomAddDialogVisible = false
                        } else {
                            this.$message.error('创建失败')
                        }
                    })
                } else if (this.action == 'edit') {
                    this.$axios.put(url,fd)
                    .then(res => {
                        if (res.status === 1) {
                            const index = this.roomList.findIndex((value) => value.id == this.editRoomId)
                            this.roomList[index] = res.data
                            this.$message.success('更新成功')
                            this.roomAddDialogVisible = false
                        } else {
                            this.$message.error('更新失败')
                        }
                    })
                }
                
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        },
        handleRemove(file, fileList) {
            this.roomAdd.pic = null
            document.getElementsByClassName('el-upload--picture-card')[0].style.display = "block"
        },
        uploadImgHandle(file) {
            let imgFile = file.raw
            this.roomAdd.pic = imgFile
            document.getElementsByClassName('el-upload--picture-card')[0].style.display = "none"
        },
        getRoomList(page){
            this.table_loading = true
            let url = null
            if (page) {
                url = '/room/?page=' + page
            } else {
                url = '/room/'
            }
            this.$axios.get(url)
            .then(res => {
                if (res.status === 1) {
                    this.roomList = res.data
                    this.total = res.total
                }
            })
            this.table_loading = false
        },
        createClick(){
            this.roomAddDialogVisible = true
            this.action = 'create'
            this.dialogTitle = '新建会议室'
        },
        editClick(row){
            this.editRoomId = row.id
            this.$axios.get('/room/'+ this.editRoomId)
            .then(res => {
                if (res.status === 1) {
                    this.roomAdd = {
                        name: res.data.name,
                        describe: res.data.describe,
                        pic: null,
                        status: res.data.status
                    }
                    this.roomAddDialogVisible = true,
                    this.action = 'edit'
                    this.dialogTitle = '编辑会议室'
                    if (res.data.pic) {
                        this.picList = [{url: res.data.pic}]
                    }
                }
            })
            .finally(() => {
                if (this.picList) {
                    document.getElementsByClassName('el-upload--picture-card')[0].style.display = "none"
                }
            })
        },
        dialogCloseHandle(){
            this.roomAdd = {
                name: null,
                describe: null,
                pic: null,
                status: 1
            }
            this.picList = []
            document.getElementsByClassName('el-upload--picture-card')[0].style.display = "block"
        },
        handlePageChange(page){
            this.getRoomList(page)
        }
    }
}
</script>
<style lang="less" scoped>
.room_page{
    padding: 20px;
    .page_pagination{
        margin-top: 50px;
        text-align: center;
    }
}

</style>